var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.03 36.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.29,
    y: 7.59,
    width: 26.82,
    height: 20.7,
    rx: 0.72,
    transform: "translate(-0.27 35.59) rotate(-86.74)",
    style: {
      fill: "#3a7ec1",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,35H29l-19-3.12A.81.81,0,0,1,9.27,31L13.37,5.9a.83.83,0,0,1,.94-.67l19,3.12a.81.81,0,0,1,.67.93l-4.1,25A.82.82,0,0,1,29,35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.81,
    y: 7.17,
    width: 26.82,
    height: 20.7,
    rx: 0.72,
    transform: "translate(-0.31 34.72) rotate(-86.74)",
    style: {
      fill: "#efc825"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,11.73l-14.91-.85a.46.46,0,0,1-.44-.49h0a.47.47,0,0,1,.49-.43l14.91.85a.46.46,0,0,1,.44.48h0A.47.47,0,0,1,26,11.73Z",
    style: {
      fill: "#efc825",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.84,15.07l-14.91-.85a.46.46,0,0,1-.44-.49h0A.47.47,0,0,1,11,13.3l14.91.85a.47.47,0,0,1,.44.49h0A.47.47,0,0,1,25.84,15.07Z",
    style: {
      fill: "#efc825",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.65,18.41l-14.91-.85a.46.46,0,0,1-.44-.49h0a.47.47,0,0,1,.49-.43l14.91.85a.47.47,0,0,1,.44.49h0A.47.47,0,0,1,25.65,18.41Z",
    style: {
      fill: "#efc825",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.46,21.75,10.55,20.9a.46.46,0,0,1-.44-.49h0A.47.47,0,0,1,10.6,20l14.91.85a.47.47,0,0,1,.44.49h0A.47.47,0,0,1,25.46,21.75Z",
    style: {
      fill: "#efc825",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.27,25.09l-14.91-.85a.46.46,0,0,1-.44-.49h0a.47.47,0,0,1,.49-.43l14.91.85a.47.47,0,0,1,.44.49h0A.47.47,0,0,1,25.27,25.09Z",
    style: {
      fill: "#efc825",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.08,28.43l-14.91-.85a.46.46,0,0,1-.44-.48h0a.47.47,0,0,1,.49-.44l14.91.85a.47.47,0,0,1,.44.49h0A.47.47,0,0,1,25.08,28.43Z",
    style: {
      fill: "#efc825",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.22,8.39,11.31,7.54a.46.46,0,0,1-.44-.49h0a.47.47,0,0,1,.49-.43l14.91.85a.46.46,0,0,1,.44.48h0A.47.47,0,0,1,26.22,8.39Z",
    style: {
      fill: "#efc825",
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.61,
    y: 2.36,
    width: 20.7,
    height: 26.82,
    rx: 0.72,
    transform: "translate(-1.27 1.14) rotate(-4.79)",
    style: {
      fill: "#3a7ec1",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.05,
    y: 1.81,
    width: 20.7,
    height: 26.82,
    rx: 0.72,
    transform: "translate(-1.23 1.09) rotate(-4.79)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32,8.39,4.44,9.64a.47.47,0,0,1-.5-.42h0a.46.46,0,0,1,.42-.5L19.24,7.47a.46.46,0,0,1,.5.42h0A.45.45,0,0,1,19.32,8.39Z",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,11.73,4.72,13a.46.46,0,0,1-.5-.43h0a.47.47,0,0,1,.42-.5l14.88-1.24a.45.45,0,0,1,.5.42h0A.47.47,0,0,1,19.6,11.73Z",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.88,15.06,5,16.31a.46.46,0,0,1-.5-.42h0a.46.46,0,0,1,.42-.5L19.8,14.14a.46.46,0,0,1,.5.42h0A.46.46,0,0,1,19.88,15.06Z",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16,18.4,5.28,19.64a.46.46,0,0,1-.5-.42h0a.47.47,0,0,1,.42-.5l14.88-1.25a.46.46,0,0,1,.5.43h0A.47.47,0,0,1,20.16,18.4Z",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44,21.73,5.56,23a.46.46,0,0,1-.5-.43h0a.47.47,0,0,1,.42-.5l14.88-1.24a.47.47,0,0,1,.5.42h0A.47.47,0,0,1,20.44,21.73Z",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.72,25.06,5.84,26.31a.46.46,0,0,1-.5-.42h0a.45.45,0,0,1,.42-.5l14.88-1.25a.47.47,0,0,1,.5.42h0A.46.46,0,0,1,20.72,25.06Z",
    style: {
      fill: "#e4ecf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,5.06,4.16,6.31a.47.47,0,0,1-.5-.43h0a.47.47,0,0,1,.42-.5L19,4.14a.46.46,0,0,1,.5.42h0A.45.45,0,0,1,19,5.06Z",
    style: {
      fill: "#e4ecf9"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDocs);
export default __webpack_public_path__ + "static/media/three_docs.a4da5e2e07b6346ce0a4c47b38408e06.svg";
export { ForwardRef as ReactComponent };